import { useTranslation } from "react-i18next";
import { useBrand } from "@webuild-ai/react-ui/hooks";
import { BrandLogo } from "@webuild-ai/react-ui/components";

import DefaultLayout from "@/layouts/default";
import { title, subtitle } from "@/components/primitives";
import { IconLoading } from "@/components/icons";

export const LoadingContent = () => {
  const { t } = useTranslation();
  const { brand } = useBrand();

  return (
    <section className="flex flex-col items-center justify-center gap-4 py-8 md:py-10">
      <div className="inline-block max-w-lg text-center justify-center">
        {brand.layout.showLogo ? (
          <BrandLogo
            className="mx-auto mb-10"
            style={{ height: brand.layout.menuItemsIconSize ?? 60 }}
          />
        ) : (
          <>
            <span className={title()}>{brand.name}&nbsp;</span>
            <span className={`${subtitle({ class: "mt-4" })} text-primary`}>
              {brand.subtitle ? t(brand.subtitle) : t("Your AI Platform")}
            </span>
          </>
        )}
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="loading-animation flex flex-col items-center">
          <IconLoading />
          <p className="mt-4 text-primary">{t("Loading...")}</p>
        </div>
      </div>
    </section>
  );
};

const LoadingPage = () => (
  <DefaultLayout>
    <LoadingContent />
  </DefaultLayout>
);

export default LoadingPage;
